// test1169
(1169 && 0);
